import React from 'react';

const PlusCircle = ({ color = 'currentColor', size = 24 }: { color?: string, size?: number }) => {
  return <svg width={size} height={size} xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd">
    <path
      fill={color}
      d="M11.5 0c6.347 0 11.5 5.153 11.5 11.5s-5.153 11.5-11.5 11.5-11.5-5.153-11.5-11.5 5.153-11.5 11.5-11.5zm0 1c5.795 0 10.5 4.705 10.5 10.5s-4.705 10.5-10.5 10.5-10.5-4.705-10.5-10.5 4.705-10.5 10.5-10.5zm.5 10h6v1h-6v6h-1v-6h-6v-1h6v-6h1v6z"/>
  </svg>;
};

export default PlusCircle;
